import { render, staticRenderFns } from "./ApplicationTypeTable.vue?vue&type=template&id=3071676f&scoped=true&"
import script from "./ApplicationTypeTable.vue?vue&type=script&lang=js&"
export * from "./ApplicationTypeTable.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationTypeTable.vue?vue&type=style&index=0&id=3071676f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3071676f",
  null
  
)

export default component.exports